export default __webpack_public_path__ + "static/media/cp_geo_zw.e7262899.svg";